import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const Results = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="rec-results" bigPaddings={true} isMargin={false}>
                <CommonTitle>Результаты</CommonTitle>
                <CommonUsualText className="rec-results__title">
                    Мы&nbsp;решили все основные задачи клиента и&nbsp;даже сделали немного больше
                </CommonUsualText>
                <div className="rec-results-points">
                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="rec-results-points__item"
                    >
                        <div className="rec-results-points__img">
                            <img
                                src="/images/pic/rec/rec-results-points__img1.png"
                                alt=""
                                loading="lazy"
                            />
                            <div className="rec-results-points__img-subtitle">
                                График Яндекс.Метрики: прирост трафика
                            </div>
                        </div>
                        <div className="rec-results-points__info">
                            <CommonSmallTitle className="rec-results-points__title">
                                01. Прирост трафика
                            </CommonSmallTitle>
                            <CommonSmallText className="rec-results-points__subtitle">
                                Обеспечили прирост небрендового уникального трафика из поисковой
                                выдачи более, чем на 50%, начиная с 1 июня 2018 по 31 августа 2019
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="rec-results-points__item rec-results-points__item--revert"
                    >
                        <div className="rec-results-points__img">
                            <img
                                src="/images/pic/rec/rec-results-points__img2.png"
                                alt=""
                                loading="lazy"
                            />
                            <div className="rec-results-points__img-subtitle">
                                График Яндекс.Метрики: запросы в ТОП
                            </div>
                        </div>
                        <div className="rec-results-points__info">
                            <CommonSmallTitle className="rec-results-points__title">
                                02. Выдача ТОП-10
                            </CommonSmallTitle>
                            <CommonSmallText className="rec-results-points__subtitle">
                                Вывели группу в ТОП-10 на 100%
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="rec-results-points__item"
                    >
                        <div className="rec-results-points__img">
                            <img
                                src="/images/pic/rec/rec-results-points__img3.png"
                                alt=""
                                loading="lazy"
                            />
                            <div className="rec-results-points__img-subtitle">
                                График Яндекс.Метрики: рост видимости
                            </div>
                        </div>
                        <div className="rec-results-points__info">
                            <CommonSmallTitle className="rec-results-points__title">
                                03. Рост видимости
                            </CommonSmallTitle>
                            <CommonSmallText className="rec-results-points__subtitle">
                                Рост видимости группы от 0 до 60%
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </div>

                <div className="rec-results-num">
                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="rec-results-num__item"
                    >
                        <CommonSmallTitle className="rec-results-num__title">
                            04. Увеличение
                        </CommonSmallTitle>
                        <CommonSmallText className="rec-results-num__subtitle">
                            Увеличили количество промежуточных целей в 8 раз за весь период работы
                            над проектом
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="rec-results-num__item"
                    >
                        <CommonSmallTitle className="rec-results-num__title">
                            05. Конверсия
                        </CommonSmallTitle>
                        <CommonSmallText className="rec-results-num__subtitle">
                            При практически не меняющемся объеме платного трафика конверсия
                            в регистрации личного кабинета выросла с 2,5% до 4%
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="rec-results-num__item"
                    >
                        <CommonSmallTitle className="rec-results-num__title">
                            06. ТОП-10
                        </CommonSmallTitle>
                        <CommonSmallText className="rec-results-num__subtitle">
                            Выполнили важную для клиента задачу — вывели очень высокочастотный ключ
                            «Экспорт» в ТОП-10 органической выдачи
                        </CommonSmallText>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
